<template>

  <v-container>

    <v-card v-show="isMounted" id="login--card" :class="getCardStyle()">

      <v-card-media src="http://localhost:8088/app/vue/static/images/login/logo.png" height="185px">
        <v-layout column align-center justify-center>

      </v-layout>
      </v-card-media>

      <v-card-title>
        <v-layout column align-center justify-center>
          <span class="headline">CAMBIAR CONTRASEÑA</span>
        </v-layout>
      </v-card-title>

      <v-card-text>
        <vuetify-form-creator
            :columns="'xs12 sm12 md12 lg12'"
            :items="fields"
            ref="form"
          ></vuetify-form-creator>
      </v-card-text>

      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn
          color="primary" flat 
          @click.native="changePassword()"
        >Enviar</v-btn>
      </v-card-actions>

    </v-card>

  </v-container>
</template>

<script>
  import theme from 'config/theme'
  import app from 'config/app'
  import VuetifyFormCreator from 'components/vuetify-form-creator/vuetify-form-creator'
  import field from 'config/forms/validations'

  export default {
    components:
    {
      VuetifyFormCreator
    },

    data () {
      return {
        appName: app.name,
        isMounted: false,
        path: this.$route.path.toLowerCase(),
        fields: [
          {
            ref: 'current-password',
            type: 'password',
            label: 'Contraseña',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            autocomplete: 'current-password',
            rules: [
              field.isRequired(),
              field.hasMaxLength(255),
              field.isComposedBy('letters|numbers|spaces')
            ],
            counter: false,
            focusNextOnEnter: true,
            required: true,
            color: 'primary'
          },
          {
            ref: 'current-password',
            type: 'password',
            label: 'Contraseña',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            autocomplete: 'current-password',
            rules: [
              field.isRequired(),
              field.hasMaxLength(255),
              field.isComposedBy('letters|numbers|spaces')
            ],
            counter: false,
            focusNextOnEnter: true,
            required: true,
            color: 'primary'
          }
        ]
      }
    },

    mounted () {
      this.isMounted = true
    },

    methods:
    {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCardStyle: function getCardStyle () {
        return 'theme--' + theme.route[this.$route.fullPath].styles.card
      },

      /**
       * Get custom parameters or use the default parameters.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      changePassword: function changePassword () {
        this.$store.dispatch('api/changePassword', {
          passwordOne: this.passwordOne,
          passwordTwo: this.passwordTwo
        }).then(() => {
          if (this.$store.getters['api/isAuthorizedUser']) {
            return this.$router.push('/admin')
          }
          this.$store.dispatch(
            'snackbar/show',
            'Usuario o contraseña incorrectos'
          )
        })
      }
    }
  }
</script>

<style lang="sass">

#change-password-page
  background: #373c40
  -webkit-transform-style: preserve-3d
  -moz-transform-style: preserve-3d
  transform-style: preserve-3d
  height: 100%

  a
   text-decoration: none

  > .container
    max-width: 500px
    margin: 0 auto
    position: relative
    top: 50%
    transform: translateY(-50%)

    .avatar
      margin-top: 50%
      background-color: #373c40

    .card__title
      margin-top: 30px
      margin-bottom: -20px

    .text-lg-right
      margin-top: 5px
</style>



// WEBPACK FOOTER //
// src/pages/change-password.vue